import styled from 'styled-components';
export const HeaderNav = styled.div`
    height: 135px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    margin: 0;

    &.minimal {
        height: 80px;
    }
    &.no-header {
        height: 0px;
    }

    @media screen and (max-width: ${props => props.theme.mobile}) {
        & {
            height: 41px;
            border-bottom: 1px solid ${props => props.theme.navBorderColor};
            box-shadow: none;
        }
        &.minimal {
            height: 41px;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/header/HeaderNavComponentStyle.js